import request from '@/plugins/axios'
const base = '/'

export function getoutsideorder(params) {
    return request({
        url: base + 'api/jd/outsideorder/get',
        method: 'get',
        params
    })
}

export function getoutsidetborder(params) {
    return request({
        url: base + 'api/jd/outsideorder/tb/get',
        method: 'get',
        params
    })
}